<template>
    <div class="w-100 big-container">
        <div class="title">{{$t('sp_select')}}</div>
        <div class="container">
            <div class="row row-sezione">
                <div class="col-12">
                    <div class="form-group">
                        <select class="form-control" @change="this.onPointPicked">
                            <option value="">{{$t('select')}}</option>
                            <option v-for="point in this.conf.punti_di_servizio" :value="point.id"
                                    :selected="id_punto_di_servizio === point.id">
                                {{point.traduzione_ll.nome}}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Lv1Dil",
    props: ['conf', 'point'],
    data() {
        return {
            id_punto_di_servizio: null
        }
    },
    created() {
        this.id_punto_di_servizio = this.point;
    },
    computed: {
        curr_point: function () {
            return this.conf.punti_di_servizio.find((point) => {
                return point.id === this.point
            });
        }
    },
    methods: {
        onPointPicked: function (e) {
            this.id_punto_di_servizio = e.target.value ? parseInt(e.target.value) : null;
            this.$emit('onPointPicked', this.id_punto_di_servizio);
        }
    }
}
</script>
